import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError} from 'rxjs';
import { catchError, retry } from 'rxjs/operators';



@Injectable({providedIn: 'root'})
export class AppInterceptorService implements HttpInterceptor {


    constructor() {}

    handleError(error) {
        let errorMessage = '';
        
        if (error.error instanceof ErrorEvent) {
          // Get client-side error
          errorMessage = error.error.message;
        } else {
          // Get server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        
        //window.alert(errorMessage);
        return throwError(errorMessage);
      }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        return next.handle(req)
        .pipe(
            retry(1),
            catchError(this.handleError)
        )
    }
}